import {create} from "zustand";
import {ComponentAnalytics, StepAnalytics} from "@/src/shared/models/analytics";

export const analyticsStore = create<{ stepAnalytics: StepAnalytics | null, componentAnalytics: ComponentAnalytics[]}>(() => ({
    stepAnalytics: null,
    componentAnalytics: []
}));

export const addStepAnalytic = (analytics: StepAnalytics | null) => {
    analyticsStore.setState(state => ({ ...state, stepAnalytics: analytics }));
};

export const updateComponentAnalytics = (analytics: ComponentAnalytics[]) => {
    analyticsStore.setState(state => ({ ...state, componentAnalytics: analytics }));
};
